<template>
	<div class="color-toggle-list">
		<color-list-item v-for="(item,index) in listItems" v-bind:key="index" :class="[currentColor.hexString==item.hexString ? 'currentColor' : '']" :color="item"></color-list-item>
	</div>
</template>
<script type="text/javascript">
	import colorListItem from "@/components/colorListItem.vue";
	export default{
		props:{
			color:{
				
			},
			mode:{
				type:String,
				default:"lchab"
			},
			increment:{
				type:Number,
				default:1
			},
			col:{
				type:Number,
				default:0
			},
			min:{
				type:Number,
				default:0
			},
			max:{
				type:Number,
				default:100
			},
			tolerance:{
				type:Array,
				default:()=>[1,1,1]
			}
		},
		data(){
			return {

			};
		},
		mounted(){
		},components:{
			"color-list-item":colorListItem
		},
		computed:{
			currentColor(){
				if(!this.color){
					return (new this.$store.state.Color());
				}else{
					return this.color;
				}
			},
			listItems(){
				let items = [];
				let colors = [];
				let colorList = this.currentColor[this.mode];
				// Set Min Color
				let minColorList = [...colorList];
				minColorList[this.col] = this.min;
				let minColor = new this.$store.state.Color({"color":minColorList,"type":this.mode});
				let toleranceValid = true;
				for(let i=0;i<3;i++){
					if(i!=this.col){
						if(Math.abs((minColor[this.mode][i]-this.currentColor[this.mode][i])/this.currentColor[this.mode][i])*100 > this.tolerance[i]){
							toleranceValid = false;
						}
					}
				}
				if(toleranceValid){
					items.push(minColor);
					colors.push(items[items.length-1].hexString);
				}
				// Set Intermediary Colors
				for(let i=(this.min+(colorList[this.col]%this.increment));i<this.max;i+=this.increment){
					let currentColor=[...colorList];
					currentColor[this.col]=i;
					let currentItem = new this.$store.state.Color({"color":currentColor,"type":this.mode});
					toleranceValid = true;
					for(let i=0;i<3;i++){
						if(i!=this.col){
							if(Math.abs((currentItem[this.mode][i]-this.currentColor[this.mode][i])/this.currentColor[this.mode][i])*100 > this.tolerance[i]){
								toleranceValid = false;
							}
						}
					}
					if(!colors.includes(currentItem.hexString) && toleranceValid){
						items.push(currentItem);
					}
				}
				// Set Max Color
				let maxColorList = [...colorList];
				maxColorList[this.col] = this.max;
				toleranceValid = true;
				let maxColor = new this.$store.state.Color({"color":maxColorList,"type":this.mode});
				for(let i=0;i<3;i++){
					if(i!=this.col){
						if(Math.abs((maxColor[this.mode][i]-this.currentColor[this.mode][i])/this.currentColor[this.mode][i])*100 > this.tolerance[i]){
							toleranceValid = false;
						}
					}
				}
				if(toleranceValid){
					items.push(maxColor);
					colors.push(items[items.length-1].hexString);
				}
				return items;
			}
		}
	}
</script>
<style type="text/css">
	.color-toggle-list{
		width: 100%;
		max-height: 35vh;
		overflow-y: scroll;
	}
</style>